<template>
  <wrapper>
      <header-logos />
      <header-titles
              blue-title="COVID19"
              main-title="Painel de Acompanhamento do Coronavírus"
              sub-title="Por XXXX em parceria com a Prefeitura XXXX"/>
      <row :key="alert.id" v-for="alert in alerts">
          <div class="col-12">
              <h6 style="background-color: yellow" class="text-center p-2">{{alert.text}}</h6>
          </div>
      </row>
      <counters
              :suspected-cases="suspected_cases"
              :confirmed-cases="confirmed_cases"
              :discarded-cases="discarded_cases"
              :last-updated="info_dash_last_update" />
      <row>
        <div class="col-md-8">
            <line-by-day :chart-data="daily_cases" :last-updated="daily_cases_last_update" />
        </div>

        <div class="col-md-4">
            <list-by-region :table-data="region_data" :last-updated="region_data_last_update" />
        </div>
      </row>
      <row>
        <div class="col-md-6">
            <pie-by-gender :chart-data="gender_data" :last-updated="gender_data_last_update"/>
        </div>
        <div class="col-md-6">
            <bars-by-age :chart-data="age_data" :last-updated="age_data_last_update"/>
        </div>
      </row>
      <row>
          <div class="col-12">
              <h5 class="text-center">*Informações recebidas da Secretaria de Saúde de XXXX</h5>
          </div>
      </row>
      <row>
          <div class="col-12">
              <img src="banner.jpeg" style="width: 100%">
          </div>
      </row>

  </wrapper>
</template>

<script>
import Wrapper from "@/components/Wrapper";
import Row from "@/components/Row";
import HeaderLogos from "@/components/HeaderLogos";
import HeaderTitles from "@/components/HeaderTitles";
import Counters from "@/components/Counters";
import LineByDay from "@/components/charts/LineByDay";
import { Directus } from "@directus/sdk";
import ListByRegion from "@/components/charts/ListByRegion";
import PieByGender from "@/components/charts/PieByGender";
import BarsByAge from "@/components/charts/BarsByAge";
export default {
  name: 'HelloWorld',
  components: {BarsByAge, PieByGender, ListByRegion, LineByDay, Counters, HeaderTitles, HeaderLogos, Row, Wrapper},
  data: function(){
    return {
        suspected_cases:0,
        confirmed_cases:0,
        discarded_cases:0,
        info_dash_last_update:0,
        daily_cases: [],
        daily_cases_last_update: null,
        region_data: [],
        region_data_last_update: null,
        gender_data: [],
        gender_data_last_update: null,
        age_data: [],
        age_data_last_update: null,
        alerts: []
    }
  },
  mounted(){
      var self = this;
      var client = new Directus('https://directus1.paganiniinformatica.com.br/');
      client.items('info_dash').readMany().then(function (response) {
          self.suspected_cases = response.data.suspect;
          self.confirmed_cases = response.data.confirmed;
          self.discarded_cases = response.data.discarded;
          self.info_dash_last_update = response.data.modified_on;
      })
      client.items('daily_cases').readMany().then(function (response) {
          self.daily_cases = response.data;
      })
      client.items('daily_cases').readMany({sort: '-date'}).then(function (response) {
          self.daily_cases_last_update = response.data[0].date;
      })
      client.items('regions').readMany({sort: '-cases'}).then(function (response) {
          self.region_data = response.data;
      })
      client.items('regions').readMany({sort:'-modified_on'}).then(function (response) {
          self.region_data_last_update = response.data[0].modified_on;
      })
      client.items('gender_cases').readMany({sort: '-cases'}).then(function (response) {
          self.gender_data = response.data;
      })
      client.items('gender_cases').readMany({sort:'-modified_on'}).then(function (response) {
          self.gender_data_last_update = response.data[0].modified_on;
      })
      client.items('age_cases').readMany({sort: 'id'}).then(function (response) {
          self.age_data = response.data;
      })
      client.items('age_cases').readMany({sort:'-modified_on'}).then(function (response) {
          self.age_data_last_update = response.data[0].modified_on;
      })
      client.items('alerts').readMany({sort: 'id'}).then(function (response) {
          self.alerts = response.data;
      })
  }
}
</script>
